import { Controller } from "@hotwired/stimulus"

// Checkout: per ogni evento (gruppo) gestisce l'aggiunta/rimozione dei partecipanti
// e calcola il totale per evento (prezzo x partecipanti) + il totale complessivo.
export default class extends Controller {
  static targets = ["grandTotal"]

  connect() {
    this.recount()
  }

  add(event) {
    event.preventDefault()
    const group = event.target.closest("[data-cp-group]")
    if (!group) return
    const template = group.querySelector("[data-cp-template]")
    const container = group.querySelector("[data-cp-container]")
    const html = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    container.insertAdjacentHTML("beforeend", html)
    this.recount()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-cp-row]")
    if (!row) return
    const container = row.closest("[data-cp-container]")
    const rows = container.querySelectorAll("[data-cp-row]")
    if (rows.length <= 1) {
      const input = row.querySelector("[data-cp-name]")
      if (input) input.value = ""
    } else {
      row.remove()
    }
    this.recount()
  }

  recount() {
    let grand = 0
    this.element.querySelectorAll("[data-cp-group]").forEach((group) => {
      const unit = parseInt(group.dataset.unitPrice || "0", 10)
      let count = 0
      group.querySelectorAll("[data-cp-container] [data-cp-name]").forEach((i) => {
        if (i.value.trim() !== "") count++
      })
      const itemCents = count * unit
      grand += itemCents
      const itemTotal = group.querySelector("[data-cp-item-total]")
      if (itemTotal) itemTotal.textContent = (itemCents / 100).toFixed(2).replace(".", ",")
    })
    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = (grand / 100).toFixed(2).replace(".", ",")
    }
  }
}
